import { App, ConfigProvider, Switch } from "antd";
import { useTranslation } from "react-i18next";
import { usePushSubscription } from "../../hooks/usePushSubscription";
import { useThemePalette } from "../../store/hooks";
import PushModalShell from "./PushModalShell";

interface PushSettingsModalProps {
  open: boolean;
  onClose: () => void;
}

// Настройка „Вкл./Изкл. известия" за ТЕКУЩИЯ потребител на това устройство —
// личен акаунт и ПИН-служител ползват един и същ модал (профил менюто).
export default function PushSettingsModal({
  open,
  onClose,
}: PushSettingsModalProps) {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const push = usePushSubscription(open);
  const themePalette = useThemePalette();

  const permissionDenied = push.permission === "denied";

  const handleToggle = async (checked: boolean) => {
    try {
      if (checked) await push.enable();
      else await push.disable();
    } catch (error) {
      console.error("Push toggle error:", error);
      message.error(t(checked ? "push.enableError" : "push.disableError"));
    }
  };

  return (
    <PushModalShell
      open={open}
      onClose={onClose}
      title={t("push.settingsTitle")}
      subtitle={t("push.settingsSubtitle")}
      closeLabel={t("common.close")}
    >
      {!push.supported ? (
        <p className="m-0 text-[13px] font-medium leading-[1.5] text-body">
          {t("push.unsupportedHint")}
        </p>
      ) : (
        <>
          <div className="flex items-center justify-between gap-3 rounded-xl border border-shade-2 bg-canvas px-3.5 py-3">
            <span className="text-[13px] font-semibold leading-[1.4] text-ink">
              {t("push.toggleLabel")}
            </span>
            {/* Switch в акцента на темата — hex от палитрата (antd token
                не резолва var()). */}
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: themePalette.accent,
                  colorPrimaryHover: themePalette.accentHover,
                },
              }}
            >
              <Switch
                checked={push.subscribed}
                loading={push.busy || push.loading}
                disabled={permissionDenied}
                onChange={handleToggle}
              />
            </ConfigProvider>
          </div>
          {permissionDenied && (
            <p className="m-0 mt-3 text-[12.5px] font-medium leading-[1.5] text-muted">
              {t("push.permissionDeniedHint")}
            </p>
          )}
        </>
      )}
    </PushModalShell>
  );
}
